const GUEST_MODE_KEY = 'guestMode';
const GUEST_INFO_KEY = 'guestInfo';

export interface GuestInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export const isGuestMode = (): boolean =>
  localStorage.getItem(GUEST_MODE_KEY) === 'true';

export const enableGuestMode = (): void => {
  localStorage.setItem(GUEST_MODE_KEY, 'true');
};

export const disableGuestMode = (): void => {
  localStorage.removeItem(GUEST_MODE_KEY);
  localStorage.removeItem(GUEST_INFO_KEY);
};

export const getGuestInfo = (): GuestInfo | null => {
  const raw = localStorage.getItem(GUEST_INFO_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as GuestInfo;
  } catch {
    return null;
  }
};

export const setGuestInfo = (info: GuestInfo): void => {
  localStorage.setItem(GUEST_INFO_KEY, JSON.stringify(info));
};
